var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"diviser"},[_vm._v(" Participação em leilões ")]),_c('div',{staticClass:"m-t"},[_c('historico-leiloes',{attrs:{"leiloes":_vm.bem.participacaoLeiloes}})],1),_c('div',{staticClass:"m-t-lg"},[_c('historico-propostas',{attrs:{"bem":_vm.bem,"router":_vm.$router}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }